import { render, staticRenderFns } from "./OffersPageBanner.vue?vue&type=template&id=24e9b3fa&scoped=true&"
import script from "./OffersPageBanner.vue?vue&type=script&lang=js&"
export * from "./OffersPageBanner.vue?vue&type=script&lang=js&"
import style0 from "./OffersPageBanner.vue?vue&type=style&index=0&id=24e9b3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9b3fa",
  null
  
)

export default component.exports